import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const ADMIN_TOKEN_KEY = "otm_admin_token";
export const DEALER_TOKEN_KEY = "otm_dealer_token";

export const api = axios.create({ baseURL: API, timeout: 20000 });

export const adminApi = axios.create({ baseURL: API, timeout: 30000 });
adminApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(ADMIN_TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// If the admin session is missing/expired/invalid (401/403), drop the stored
// token and bounce to the login screen instead of leaving the console stuck.
adminApi.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if ((status === 401 || status === 403) && !url.includes("/admin/login")) {
      localStorage.removeItem(ADMIN_TOKEN_KEY);
      if (!window.location.pathname.endsWith("/admin/login")) {
        window.location.assign("/admin/login?expired=1");
      }
    }
    return Promise.reject(err);
  }
);

export const dealerApi = axios.create({ baseURL: API, timeout: 30000 });
dealerApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(DEALER_TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
dealerApi.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if ((status === 401 || status === 403) && !url.includes("/dealer/login")) {
      localStorage.removeItem(DEALER_TOKEN_KEY);
      if (!window.location.pathname.startsWith("/dealer/login")) {
        window.location.assign("/dealer/login?expired=1");
      }
    }
    return Promise.reject(err);
  }
);

export function getErrorMessage(e, fallback = "Something went wrong. Please try again.") {  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Streaming chat over SSE via fetch
export async function streamChat(body, { onToken, onDone, onError, onStatus, onAudio }) {
  try {
    const res = await fetch(`${API}/chat/stream`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    if (!res.ok || !res.body) {
      onError?.(new Error(`Request failed (${res.status})`));
      return;
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      let idx;
      while ((idx = buffer.indexOf("\n\n")) >= 0) {
        const chunk = buffer.slice(0, idx);
        buffer = buffer.slice(idx + 2);
        const line = chunk.split("\n").find((l) => l.startsWith("data:"));
        if (!line) continue;
        let ev;
        try {
          ev = JSON.parse(line.slice(5).trim());
        } catch {
          continue;
        }
        if (ev.type === "token") onToken?.(ev.content);
        else if (ev.type === "done") onDone?.(ev);
        else if (ev.type === "status") onStatus?.(ev.content);
        else if (ev.type === "audio") onAudio?.(ev);
      }
    }
  } catch (e) {
    onError?.(e);
  }
}
